/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { __platform_browser_private__ as _ } from '@angular/platform-browser';
export var INTERNAL_BROWSER_PLATFORM_PROVIDERS = _.INTERNAL_BROWSER_PLATFORM_PROVIDERS;
export var getDOM = _.getDOM;
//# sourceMappingURL=private_import_platform-browser.js.map


//////////////////
// WEBPACK FOOTER
// /www/sms-simulator/sms-front/~/@angular/platform-browser-dynamic/src/private_import_platform-browser.js
// module id = ../../../platform-browser-dynamic/src/private_import_platform-browser.js
// module chunks = 3